import React from 'react';
import './AboutUs.css';

function AboutUs({ theme, onBackClick }) {
    const contactEmail = 'sankalph1234@gmail.com';
    const contactLinkedIn = 'https://www.linkedin.com/in/sankalp-hegde-48895123a/';

    return (
        <div className={`app ${theme}`}>
            <main>
                <section className="about-header-section">
                    <div className="about-header">
                        <h1>About Us</h1>
                        <button className="back-btn" onClick={onBackClick}>
                            Return to Gallery
                        </button>
                    </div>
                </section>

                <section className="about-content">
                    <div className="mission-card">
                        <h2>Our Mission</h2>
                        <p>
                            At Stupidly Designed Products, we celebrate the absurd and impractical. In a world obsessed with productivity and efficiency, I've decided to go the opposite direction. I curated the finest examples of wonderfully useless inventions—(products, services and more..) that triumph of imagination over practicality. Every item in the collection is genuinely useless in the most creative way possible.
                            Hopefully some products bring a smile to your face and a moment of joy in an otherwise harsh world. I believe that sometimes, the best way to appreciate the value of things is to embrace their lack of it. So go ahead, explore the gallery of useless products, and remember: not everything needs to be useful to be enjoyed!
                        </p>
                    </div>

                    <div className="contact-card">
                        <h2>Get in Touch</h2>
                        <div className="contact-links">
                            <a href={`mailto:${contactEmail}`} className="contact-link">
                                <span className="contact-icon">✉</span>
                                {contactEmail}
                            </a>
                            <a href={contactLinkedIn} target="_blank" rel="noopener noreferrer" className="contact-link">
                                <span className="contact-icon">in</span>
                                {contactLinkedIn.split('https://www.linkedin.com/in/')[1]}
                            </a>
                        </div>
                    </div>
                </section>
            </main>

            <footer className="footer">
                <p>© 2026 StupidDesigns.com. All rights reserved. Not that anyone actually wants them.</p>
            </footer>
        </div>
    );
}

export default AboutUs;
